<div class='map'>
<div class='lgr_col'><dynamic-field [id]='"text"' [size]=80 [(ngModel)]='text'></dynamic-field></div>
</div>